import { ButtonHTMLAttributes, ReactNode } from 'react';
import { Loader2 } from 'lucide-react';

interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'danger' | 'ghost';
  loading?: boolean;
  icon?: ReactNode;
}

export function Button({ variant = 'primary', loading, icon, children, className = '', ...props }: ButtonProps) {
  const variants = {
    primary: 'bg-gradient-to-r from-neon-violet via-neon-magenta to-neon-blue text-white shadow-neon hover:brightness-110',
    secondary: 'border border-white/10 bg-white/[0.08] text-white hover:border-neon-violet hover:bg-white/[0.13]',
    danger: 'bg-danger text-white shadow-[0_0_28px_rgba(239,68,68,0.26)] hover:bg-red-700',
    ghost: 'bg-transparent text-slate-200 hover:bg-white/[0.08]'
  };

  return (
    <button
      className={`focus-ring inline-flex min-h-10 items-center justify-center gap-2 rounded-full px-4 py-2 text-sm font-semibold transition disabled:cursor-not-allowed disabled:opacity-60 ${variants[variant]} ${className}`}
      disabled={loading || props.disabled}
      {...props}
    >
      {loading ? <Loader2 className="h-4 w-4 animate-spin" /> : icon}
      {children}
    </button>
  );
}
